<template>
    <div style="display: flex; width: 100%; align-items: stretch; justify-content: center">
        <input type="text" v-bind:value="fileLabel" readonly style="flex-grow: 1">
        <label style="display: flex">
            <input type="file"
                   v-on:change="handleChange($event)"
                   :ref="'fileinput'"
                   style="visibility: hidden; width: 0; height: 0; padding: 0; margin: 0; border: 0; opacity: 0; flex-grow:0">
            <button v-html="label"
                    type="button"
                    :class="buttonClass" v-on:click="$refs['fileinput'].click()"></button>
        </label>
    </div>
</template>

<script>
    export default {
        props: {
            value: {},
            label: {type: String},
            buttonClass: {type: String},
        },
        data: function () {
            return {
                file: null,
            }
        },
        mounted() {

        },
        methods: {
            handleChange: function(payload) {
                if ((payload) && (payload.target) && (payload.target.files[0])) {
                    this.$emit('input', payload.target.files[0]);
                } else {
                    this.$emit('input', null);
                }
            }
        },
        computed: {
            fileLabel: function() {
                if (this.file) {
                    return this.file.name;
                }
            }
        },
        watch: {
            value: function() {
                this.file = this.value;
            }
        }

    }
</script>
